import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BlogGrid.css';

const CATEGORIES = ['All', 'Culture', 'Drops', 'Style', 'Tech', 'Community'];

export default function BlogGrid({ posts }) {
  const [activeCategory, setActiveCategory] = useState('All');
  const navigate = useNavigate();

  const filtered = activeCategory === 'All'
    ? posts
    : posts.filter(p => p.category === activeCategory);

  const formatDate = (d) => new Date(d).toLocaleDateString('en-ZA', {
    day: 'numeric', month: 'short', year: 'numeric'
  });

  return (
    <div className="bg-wrap">
      <div className="bg__inner">

        {/* Header */}
        <div className="bg__header">
          <div className="bg__header-text">
            <p className="bg__eyebrow">L a t e s t &nbsp; F r o m &nbsp; T h e &nbsp; L a b</p>
            <h2 className="bg__title">THE DROP<br />JOURNAL</h2>
          </div>

          {/* Category filter */}
          <div className="bg__filters">
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                className={`bg__filter${activeCategory === cat ? ' bg__filter--on' : ''}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Grid */}
        {filtered.length === 0 ? (
          <div className="bg__empty">
            <p>No posts in this category yet.</p>
          </div>
        ) : (
          <div className="bg__grid">
            {filtered.map((post, i) => (
              <article
                key={post.id}
                className={`bg-card${i === 0 ? ' bg-card--feature' : ''}`}
                onClick={() => navigate(`/blog/${post.slug}`)}
              >
                {/* Image */}
                <div className="bg-card__img-wrap">
                  <img
                    src={post.cover_image || 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&q=85'}
                    alt={post.title}
                    className="bg-card__img"
                  />
                  <span className="bg-card__category">{post.category}</span>
                </div>

                {/* Content */}
                <div className="bg-card__body">
                  <h3 className="bg-card__title">{post.title}</h3>
                  {i === 0 && (
                    <p className="bg-card__excerpt">{post.excerpt}</p>
                  )}
                  <div className="bg-card__footer">
                    <div className="bg-card__meta">
                      <span className="bg-card__author">{post.author}</span>
                      <span className="bg-card__date">{formatDate(post.created_at)}</span>
                    </div>
                    <span className="bg-card__link">
                      Read
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"/>
                        <polyline points="12 5 19 12 12 19"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}